<template lang="pug">
  section.looper(v-if="!sponsorsLoading")
    .bg
      VideoPlayer(v-if="video", :video="video", :poster="poster")

    .sponsorwrap(v-for="(post, index) in sponsors.slice(0)", :to="post.slug", :key="post.id")
      SponsorItem(:post="post", :position="isEvenOrOdd(index + 1)")
</template>

<script>
import SponsorItem from '@/components/ironman/SponsorItem'
import VideoPlayer from '@/components/VideoPlayer'

export default {
  props: {
    sponsors: Array,
    sponsorsLoading: Boolean,
    video: String,
    poster: String
  },
  components: {
     SponsorItem,
     VideoPlayer
  },
  methods: {
    isEvenOrOdd(index){
      const ret = index % 2 == 0 ? 'even' : 'odd'
      return ret
    }
  }
}
</script>
<style lang="scss" scoped>
  .looper{
    position: relative;
    overflow: hidden;
    .bg{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
  .sponsorwrap{
    margin: 0 auto;
    max-width: $uberwidth;
    position: relative;
    z-index: 2;
  }
</style>



